import moment from "moment";
import logo2 from "../../img/autoagendamientov2/logo_ike_home.png";
import logoMty from "../../img/autoagendamientov2/mty.png";
import { Col, Container, Row } from "react-bootstrap";

export default function AutoagendmientoFooter({ configuration, cita = null }) {
  //console.log(configuration)
  return (
    <div className="bg-footer-1 pt-5 pb-2 div-footer">
      <Container>
        <Row>
          <Col xs="12" md={{ span: 10, offset: 1 }}>
            <div className="d-column d-md-flex justify-content-between mb-5">
              <div>
              {cita ? (
                <img
                  src={cita.account?.id === 1163 ? logoMty : logo2}
                  //src={logo2}
                  alt="Iké"
                  width={120}
                />
              ) : null}
              </div>
              <div>
                <span className="d-block text-white mb-1">
                  <a
                    href={`tel:${cita?.account?.partner?.company?.telephone}`}
                    className="text-white"
                  >
                    {cita?.account?.partner?.company?.telephone ?? ""}
                  </a>
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <hr className="hr-1" />
      <small className="text-white d-block text-center fs--7 pt-1">
        Copyright @{moment().format("YYYY")} iké
      </small>
    </div>
  );
}
